<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{this.route.menuName}}</span>
      </div>
      <div class="header">
        <div class="left">
                          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <!-- <div class="search">
            <input type="text" v-model="query.productName" @change="queryChange" />
            <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i>
          </div>
          <span v-preventReClick @click="reset">重置</span> -->
        </div>
      </div>
      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
        <template slot="before">
          <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
          </el-table-column>
        </template>
          <template slot="after">
            <el-table-column fixed="right" prop="operation" label="操作" min-width="260">
              <template slot-scope="scope">
                <el-button type="text" size="small" v-preventReClick class="color-blue" @click="viewClick(scope.row)">查看履历</el-button>
                <!-- <el-button type="text" size="small" @click="print(scope.row)" v-preventReClick class="color-blue"> RFID打印 </el-button> -->
                <!-- @click="print(scope.row)" -->
                <el-button type="text" size="small" v-if="scope.row.state != 0" @click="print1(scope.row)" class="margin-left20 color-blue">普通打印</el-button>
                <!-- @click="handleDelete(scope.row)" -->
                <el-button v-if="scope.row.enableState == 1" size="small" type="text" v-preventReClick
                  class="margin-left20 color-blue" @click="cancelCoed(scope.row)" >作废</el-button>
    
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
      <div v-else>
        <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
          <template slot="empty">
            <div class="empty-div" :style="{ height: tableHeight + 'px' }">
              <img src="../../../../assets/noData.png" width="240" height="240" />
              <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
              <div class="empty-rest" @click="reset">恢复默认</div>
            </div>
          </template>
          <el-table-column prop="no" label="单号" min-width="180">
            <template slot-scope="scope">
          <span>
            <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
          </span>
        </template>
          </el-table-column>
          <el-table-column prop="warehouseName" label="库房" min-width="180"></el-table-column>
          <el-table-column prop="createdUserName" width="120" label="发起人" show-overflow-tooltip></el-table-column>
          <el-table-column prop="ownerDeptName" width="150" label="所属科室" show-overflow-tooltip></el-table-column>
                 <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center" prop="approverNames"></el-table-column>
          <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
            <template slot-scope="scope">
              <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
            </template>
          </el-table-column>
               <el-table-column prop="createdTime" width="170" label="创建时间">
            <template slot-scope="scope">
              {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
            </template>
          </el-table-column>
        <el-table-column width="180" prop="effectiveTime" label="生效时间">
                  <template slot-scope="scope">
                    <div v-if="scope.row.effectiveTime">
                      <div>
                        {{ parseTime(new Date(scope.row.effectiveTime), "{y}-{m}-{d}") }}
                      </div>
                      <div>
                        {{ parseTime(new Date(scope.row.effectiveTime), "{h}:{i}:{s}") }}
                      </div>
                    </div>
                    <div v-else>-</div>
                
                  </template>
                </el-table-column>
        
          <el-table-column fixed="right" prop="operation" label="操作" width="180">
            <template slot-scope="scope">
              <el-button v-if="      scope.row.status != 1 &&
            scope.row.status != 2 &&
            tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
                                    <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
              <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
   

    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
 
  </div>
</template>

<script>
import {
  GetLocationMoves,
  RemoveLocationMoves,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import { StockCategoryOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from '@/mixin/baseList-mixin.js'
export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,

  },
  data () {
    return {
      GetDatasAction: GetLocationMoves,
      RemoveAction: RemoveLocationMoves,
      // PrintAction: SpdGetStockProfitLossPrintData,
      editPath: 'locationMove-edit',

      StockCategoryOptions: StockCategoryOptions,
      filterOptions: [
           {
          name: "单号",
          type: "input",
          code: "keyWord",
        },
        {
          name: "库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getWarehouses,
          data: [],
        },
      
    
   
        // {
        //   name: "主条码",
        //   type: "input",
        //   code: "mainNo",
        // },
      ],

    };
  },
  methods: {
 
  
  },
  mounted () {
    
  },
};
</script>

<style lang="scss" scoped></style>
